/** @format */

import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { setOpenRegister as setActiveRegister, autoOpenRegister } from "../../ReduxToolkit/Reducers/CartReducer";
import {
  addNewRegister,
  setLoading,
} from "../../ReduxToolkit/Reducers/AppReducer";
import { toast } from "react-toastify";
import http from "../../services/http";
import { getAPIURL, getUserID, getVendorID } from "../../services/helper";

const api_url = getAPIURL();
const vendor_id = getVendorID();
const biller_id = getUserID();

const RegistersModal = ({ isOpen, toggle }) => {
  const { registers, register_id } = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  // console.log(registers);

  const [registerTitle, setRegisterTitle] = useState("");
  const [openRegister, setOpenRegister] = useState(null);

  useEffect(() => {
    const activeRegister = registers.find(
      (reg) => reg.id === register_id && reg.status === "open"
    );
    setOpenRegister(activeRegister || null);
    
    // Auto-open register if none exists
    if (!activeRegister && registers.length === 0) {
      dispatch(autoOpenRegister());
    }
  }, [registers, register_id, dispatch]);

  const handleCreateRegister = async () => {
    if (!registerTitle.trim()) {
      toast.error("Please enter a register name/ID.");
      return;
    }

    dispatch(setLoading(true));

    try {
      const payload = {
        vendor_id,
        biller_id,
        initial_cash: 0,
        title: registerTitle,
        close_existing: openRegister ? openRegister.id : null,
      };

      const { data: new_register } = await http.post(
        `${api_url}/open-register`,
        payload
      );

      dispatch(setLoading(false));

      if (!new_register.success) {
        toast.error("Failed to open new register.");
        return;
      }

      dispatch(addNewRegister(new_register.data));
      dispatch(setActiveRegister(new_register.data.id)); // Update active register
      toast.success("New register opened successfully.");
      toggle(); // Close modal
    } catch (error) {
      toast.error("Error opening register. Try again.");
      dispatch(setLoading(false));
    }
  };

  return (
    <Modal isOpen={isOpen} backdrop="static" centered>
      <ModalHeader>Select or Open a Register</ModalHeader>
      <ModalBody>
        {openRegister ? (
          <>
            <p>Select an existing register:</p>
            <div
              className="register-item selected"
              style={{
                padding: "10px",
                margin: "5px 0",
                cursor: "pointer",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            >
              <p>
                <strong>{openRegister.title}</strong> - Opened by{" "}
                {openRegister.cashier}
              </p>
              <p>Initial Cash: {openRegister.initial_cash}</p>
              <p>Status: {openRegister.status}</p>
            </div>
          </>
        ) : (
          <p>No open registers available. Please create a new one.</p>
        )}

        {openRegister && (
          <Button
            color="success"
            className="mt-2"
            onClick={() => {
              dispatch(setActiveRegister(openRegister.id));
              toggle();
            }}
          >
            Use This Register
          </Button>
        )}

        <hr />

        <h5>New Register</h5>
        <Input
          type="text"
          placeholder="Enter Register Name/ID"
          value={registerTitle}
          onChange={(e) => setRegisterTitle(e.target.value)}
        />
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleCreateRegister}>
          {openRegister ? "Close existing, open New" : "Open New Register"}
        </Button>
        <Button color="danger" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RegistersModal;
